import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import {
  StyledWinningCriteriaSectionHeader,
  StyledWinningCriteriaWrapper,
  StyledSendTimeWrapper,
  StyledLabelWrapper,
  StyledPaddedCriteriaWrapper,
  StyledUsersTimezoneLabel,
  StyledTimeZonePickerWrapper,
} from 'modules/experiments/components/pages/edit/sections/settings/styled';
import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { UpdateExperimentSettingsFormFieldNames } from 'modules/experiments/constants/updateExperimentSettings';
import { ToggleField } from 'lib/iterable-hook-form';
import { TimeZonePickerField } from 'lib/iterable-hook-form/FormField';
import { FormField } from 'ui/formField';
import { TOGGLE_SIZES } from 'ui/toggle';
import { ALIGNMENT } from 'ui/menu/constants';

export const SendTimeForm = () => {
  const { t } = useExperimentsTranslations();
  const {
    sendTimeMetaInfo: { setSendTimeStartTimeZone, setSendTimeUseRecipientTimeZones },
  } = useTakeoverExperimentContext();

  const { SEND_TIME_START_TIME_ZONE, SEND_TIME_USE_RECIPIENT_TIME_ZONE } =
    UpdateExperimentSettingsFormFieldNames;

  const [startTimeZone, useRecipientTimeZone] = useWatch({
    name: [SEND_TIME_START_TIME_ZONE, SEND_TIME_USE_RECIPIENT_TIME_ZONE],
  });

  useEffect(() => {
    setSendTimeUseRecipientTimeZones(useRecipientTimeZone);
  }, [useRecipientTimeZone]);

  useEffect(() => {
    setSendTimeStartTimeZone(startTimeZone);
  }, [startTimeZone]);

  return (
    <>
      <StyledWinningCriteriaSectionHeader>
        {t('settings.sendTime.header')}
      </StyledWinningCriteriaSectionHeader>

      <StyledWinningCriteriaWrapper>
        <div>{t('settings.sendTime.startTimezone')}</div>
        <StyledTimeZonePickerWrapper>
          <FormField hasError={!!SEND_TIME_START_TIME_ZONE}>
            <TimeZonePickerField
              data-test="send-time-start-time-zone"
              verticalAlignment={ALIGNMENT.DOWN}
              name={SEND_TIME_START_TIME_ZONE}
            />
          </FormField>
        </StyledTimeZonePickerWrapper>
      </StyledWinningCriteriaWrapper>
      <StyledPaddedCriteriaWrapper>
        <StyledUsersTimezoneLabel>
          {t('settings.sendTime.sendInUsersTimezone')}
        </StyledUsersTimezoneLabel>
        <StyledSendTimeWrapper>
          <FormField hasError={!!SEND_TIME_USE_RECIPIENT_TIME_ZONE} isHorizontalLayout>
            <ToggleField
              id="send-time-use-recipient-time-zone"
              name={SEND_TIME_USE_RECIPIENT_TIME_ZONE}
              size={TOGGLE_SIZES.SMALL}
              data-test="send-time-use-recipient-time-zone"
            />
          </FormField>
          <StyledLabelWrapper>
            {useRecipientTimeZone ? t('settings.sendTime.on') : t('settings.sendTime.off')}
          </StyledLabelWrapper>
        </StyledSendTimeWrapper>
      </StyledPaddedCriteriaWrapper>
    </>
  );
};
